// Project images — thesis
import thesis_homepage from '../assets/img/projects-img/thesis-homepage.png';
import thesis_wards    from '../assets/img/projects-img/thesis-wards.png';
import thesis_nurse    from '../assets/img/projects-img/thesis-nurse.png';
import thesis_patient  from '../assets/img/projects-img/thesis-patient.png';

// Project images — rainn
import rainn_home      from '../assets/img/projects-img/rainn-home.png';
import rainn_aboutme   from '../assets/img/projects-img/rainn-aboutme.png';
import rainn_eb        from '../assets/img/projects-img/rainn-eb.png';
import rainn_expertise from '../assets/img/projects-img/rainn-expertise.png';

// Project images — jobfinder
import jobfinder_start   from '../assets/img/projects-img/jobfinder-start.png';
import jobfinder_home    from '../assets/img/projects-img/jobfinder-home.png';
import jobfinder_details from '../assets/img/projects-img/jobfinder-details.png';

// Project images — library system
import librarysystem_home     from '../assets/img/projects-img/librarysystem-home.png';
import librarysystem_about    from '../assets/img/projects-img/librarysystem-about.png';
import librarysystem_menu     from '../assets/img/projects-img/librarysystem-menu.png';
import librarysystem_contact  from '../assets/img/projects-img/librarysystem-contact.png';
import librarysystem_register from '../assets/img/projects-img/librarysystem-register.png';

// Project images — WIO
import wio_home        from '../assets/img/projects-img/wio-home.png';
import wio_about       from '../assets/img/projects-img/wio-about.png';
import wio_menu        from '../assets/img/projects-img/wio-menu.png';
import wio_contact     from '../assets/img/projects-img/wio-contact.png';
import wio_reservation from '../assets/img/projects-img/wio-reservation.png';

// Project images — oracle
import oracle_login from '../assets/img/projects-img/oracle-login.png';
import oracle_home  from '../assets/img/projects-img/oracle-home.png';
import oracle_list  from '../assets/img/projects-img/oralce-list.png';

/**
 * All project data in one place. Categories: 'web' | 'mobile' | 'other'
 */
export const PROJECTS = [
  // ---- Web Projects ----
  {
    id: 'thesis',
    category: 'web',
    title: 'Patient Acuity Monitoring System',
    subtitle: 'Thesis Project',
    description:
      'A collaborative project with a medical company in the Philippines. Developed a patient monitoring solution that uses acuity scoring to improve nurse-to-patient staffing decisions.',
    tech: ['PHP', 'Javascript', 'MySQL', 'HTML', 'CSS', 'Python'],
    images: [thesis_homepage, thesis_wards, thesis_nurse, thesis_patient],
  },
  {
    id: 'rainn',
    category: 'web',
    title: 'Rainn Website',
    subtitle: 'Commissioned Project',
    description:
      'A commissioned portfolio/showcase website for a BS Multimedia Arts student, featuring a clean and artistic design.',
    tech: ['HTML', 'CSS', 'JavaScript'],
    images: [rainn_home, rainn_aboutme, rainn_eb, rainn_expertise],
  },
  {
    id: 'library',
    category: 'web',
    title: 'Library Management System',
    subtitle: 'Commissioned Project',
    description:
      'A full-featured library website with cataloguing, member registration, and contact capabilities.',
    tech: ['PHP', 'MySQL', 'HTML', 'CSS', 'Javascript'],
    images: [librarysystem_home, librarysystem_about, librarysystem_menu, librarysystem_contact, librarysystem_register],
  },
  {
    id: 'wio',
    category: 'web',
    title: 'Winging It Online',
    subtitle: 'Client-Based Project',
    description:
      'A client project developed for a small business owner as part of a course requirement — includes an online menu, reservations, and contact features.',
    tech: ['HTML', 'CSS', 'JavaScript', 'PHP', 'MySQL'],
    images: [wio_home, wio_about, wio_menu, wio_contact, wio_reservation],
  },

  // ---- Mobile Projects ----
  {
    id: 'jobfinder',
    category: 'mobile',
    title: 'Job Finder App',
    subtitle: 'Commissioned Project',
    description:
      'A mobile app that helps users discover job listings with intuitive search and detail views.',
    tech: ['Ionic', 'TypeScript'],
    images: [jobfinder_start, jobfinder_home, jobfinder_details],
  },

  // ---- Other Projects ----
  {
    id: 'oracle',
    category: 'other',
    title: 'CRUD via Oracle DB',
    subtitle: 'Commissioned Project',
    description:
      'A simple CRUD application connected to an Oracle database running inside a virtual machine.',
    tech: ['Oracle DB', 'MySQL'],
    images: [oracle_login, oracle_home, oracle_list],
  },
];

/**
 * Tab configuration for the Projects section
 */
export const PROJECT_TABS = [
  { key: 'web',    label: 'Websites' },
  { key: 'mobile', label: 'Mobile' },
  { key: 'other',  label: 'Others' },
];
